import React from 'react';

import isMobile from 'ismobilejs';

const Adaptive = (props) => {
  const { DekstopComponent, MobileComponent, adaptiveProps, type = 'any' } = props;

  return isMobile()[type] ? (
    <MobileComponent {...adaptiveProps} />
  ) : (
    <DekstopComponent {...adaptiveProps} />
  );
};

export default Adaptive;
